import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sparkles, ArrowRight } from "lucide-react";
import { startSubscribe } from "@/lib/subscription";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { cn } from "@/lib/utils";
import { translateFr as tfr } from "@/i18n";

const errMsg = (e, fb) => {
  const d = e?.response?.data?.detail;
  return (d && (d.message || (typeof d === "string" ? d : null))) || e?.message || fb;
};

/** Universal "Subscribe / Activate" button — Stripe Payment Link resolved server-side. */
export default function SubscribeButton({
  label,
  planId,
  variant,
  size,
  className,
  showIcon = true,
  testid = "subscribe-btn",
  target = "same",
}) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      const res = await startSubscribe({ planId, user, target });
      if (res?.demo) {
        toast.success(res.message || tfr("Mode démo : aucun paiement réel ne sera effectué."));
        setLoading(false);
      }
    } catch (e) {
      toast.error(errMsg(e, tfr("Impossible de démarrer l'abonnement")));
      setLoading(false);
    }
  };

  const resolvedClass = variant
    ? className
    : cn(
        "gap-2 bg-foreground text-background hover:bg-foreground/90 active:scale-[0.97] transition-all",
        className
      );

  return (
    <Button
      onClick={handleClick}
      disabled={loading}
      variant={variant}
      size={size}
      className={resolvedClass}
      data-testid={testid}
    >
      {showIcon && <Sparkles className="h-4 w-4" />}
      {loading ? tfr("Redirection…") : label || tfr("Activer maintenant")}
      {!loading && <ArrowRight className="h-4 w-4" />}
    </Button>
  );
}
